angular.module('clients')
    .component('clientCard', {
        bindings: {
            item: '<',
            labelKey: '@',
            options: '<?',
        },
        template: `
            <div ng-if="$ctrl.item" style="margin-bottom: 10px">
                <div class="form-group" ng-if="$ctrl.labelKey"><label>{{ $ctrl.labelKey | translate }}</label></div>
                <div class="client-lead-card">
                    <client-list-format clients="[$ctrl.item]" ng-if="$ctrl.options.showSymbol === true"></client-list-format>
                    <client-name-list-format clients="[$ctrl.item]"></client-name-list-format>
                    <div ng-if="$ctrl.item.fullAddress">{{$ctrl.item.fullAddress}}</div>
                    <div ng-if="$ctrl.item.fullAddress == null && ($ctrl.item.address || $ctrl.item.postcode || $ctrl.item.city)">
                        <span ng-if="$ctrl.item.address">{{$ctrl.item.address}}</span>
                        <span ng-if="$ctrl.item.address && ($ctrl.item.postcode || $ctrl.item.city)">,&nbsp;</span>
                        <span ng-if="$ctrl.item.postcode">{{$ctrl.item.postcode}}</span>
                        <span ng-if="$ctrl.item.postcode && $ctrl.item.city">&nbsp;</span>
                        <span ng-if="$ctrl.item.city">{{$ctrl.item.city}}</span>
                    </div>
                    <div ng-if="$ctrl.item.nip"><span class="bold">NIP:&nbsp;</span>{{$ctrl.item.nip}}</div>
                </div>
            </div>
        `,
        controller: function () {
            const ctrl = this;

            ctrl.$onInit = () => {
                let defaultOptions = {
                    showSymbol: true,
                }
                ctrl.options = angular.extend({}, defaultOptions, ctrl.options);
            };
        }
    })
